import React, { useContext, useState } from 'react';
import { Drawer, Layout, Modal } from 'antd';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { thin } from '@fortawesome/fontawesome-svg-core/import.macro';
import NwBookHeader from './NwBookHeader';
import { BookLayoutContext } from 'contexts/BookLayoutContext';
import PackageInfo from 'components/PackageInfo/PackageInfo';
import NwDivider from 'components/Gui/NwDivider';
import { ConfigContext } from 'contexts/ConfigContext';
import NwBookCredits from './NwBookCredits';
import ModelNote from 'components/Model/ModelNote';
import PackageIndex from 'components/PackageIndex/PackageIndex';

const { Sider } = Layout;

const Wrapper = styled(Layout)`
    background-color: ${props => props.theme.LayoutBodyBackground};
    transition: all 0.2s;

    @media (max-width: 640px) {
        margin-left: 0 !important;
    }

    .ant-layout-sider {
        background-color: ${props => props.theme.LayoutSiderBackground};
        border-left: 1px solid ${props => props.theme.BorderColor};
        z-index: 90;
        overflow: auto;
        height: calc(100vh);
        position: fixed;
        top: 0;
        right: 0;
        @media (max-width: 640px) {
            display: none;
        }

        .sider-content {
            padding: .5rem 0 2rem 0;
            position: relative;

            .sider-close-icon {
                font-size: 2.5rem;
                cursor: pointer;
                margin-bottom: 1.4rem;
                left: 1.5rem;
                position: absolute;
            }

            .package-info-container {
                padding-left: 4rem;
                min-height: ${props => props.$headerHeight ? `calc(${props.$headerHeight} - 24px)` : '102px'};
            }

            .divider-wrapper {
                padding: 0 1rem;
            }
        }
    }

    .ant-layout-content {
        min-height: ${props => props.$headerHeight ? `calc(100vh - ${props.$headerHeight})` : '100vh'};
    }
`;

const StyledModal = styled(Modal)`
  top: 12rem;
  left: 1rem;
  
  .ant-modal-content {
    border-radius: 0;

    .ant-modal-header {
      border-bottom: 1px solid ${props => props.theme.BorderColor};
      border-radius: 0;
    }
  }
  
`;


const NwBookLayout = ({
    children,
    model,
    activePlaylist,
}) => {

    const { siderOpen, toggleSider, siderWidth, headerHeight, siderAsDrawer } = useContext(BookLayoutContext);
    const { clientConfig } = useContext(ConfigContext)
    const [isModalOpen, setIsModalOpen] = useState(true);


    let showPackageInfo = true;
    if (clientConfig && clientConfig.packageInfo && clientConfig.packageInfo.show === false) {
        showPackageInfo = false;
    }

    return (
        <Wrapper $headerHeight={`${headerHeight}px`}>
            {siderAsDrawer
                ?
                <Drawer
                    placement="right"
                    open={siderOpen}
                    onClose={toggleSider}
                    width={siderWidth}
                    title="Package Index"
                    bodyStyle={{ padding: 0 }}
                >
                    <div className="sider-content">
                        <div className="package-info-container">
                            {showPackageInfo &&
                                <PackageInfo drawerMode />
                            }
                        </div>
                        <div className="divider-wrapper">
                            <NwDivider/>
                        </div>
                        <PackageIndex currentModel={model} activePlaylist={activePlaylist} />
                    </div>
                </Drawer>
                :
                <Sider
                    collapsible={true}
                    collapsed={!siderOpen}
                    collapsedWidth={0}
                    trigger={null}
                    width={siderWidth}
                >
                    <div className="sider-content">
                        <div className="sider-close-icon" onClick={() => toggleSider()}>
                            <FontAwesomeIcon icon={thin("angle-right")} />
                        </div>
                        <div className="package-info-container">
                            {showPackageInfo &&
                                <PackageInfo drawerMode />
                            }
                        </div>
                        <div className="divider-wrapper">
                            <NwDivider />
                        </div>
                        <PackageIndex currentModel={model} activePlaylist={activePlaylist} />
                    </div>
                </Sider>
            }
            <Layout className="site-layout" style={{ marginRight: (siderOpen && !siderAsDrawer) ? `${siderWidth}px` : 0 }}>
                <NwBookHeader
                    model={model}
                />
                {children}
                {model && model.Note &&
                    <StyledModal
                        open={isModalOpen}
                        closable
                        mask
                        footer={null}
                        onCancel={() => setIsModalOpen(false)}
                        centered
                        maskClosable
                    >
                        <ModelNote modelNote={model.Note} />
                    </StyledModal>
                }
            </Layout>
            <NwBookCredits />
        </Wrapper>
    )
};

export default NwBookLayout;